import { BuildConfig } from './BuildConfig'

export const initialReportBuildConfig: BuildConfig = {
  actionsOrder: ['pick'],
  pick: {
    topLevelSections: {
      textIds: [
        'INCIDENT DESCRIPTION',
        'CURRENT SYMPTOMS:',
        'PRIOR MEDICAL PROVIDERS',
        'MEDICAL HISTORY',
        'FAMILY MEDICAL HISTORY'
      ]
    }
  }
} as const
